export default "__VITE_ASSET__xruZi9Zn__"